import * as LoadsUtils from './loads-utils';

export default LoadsUtils;
